import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Refresh = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.7 20.404-4.49 4.59c-.398.398-1.097.498-1.496 0l-4.59-4.59c-.398-.4-.398-.898 0-1.297.3-.4.899-.4 1.298 0l3.193 3.192V22.1c0-8.58-6.985-15.565-15.565-15.565-6.286 0-11.773 3.692-14.168 9.08-.2.399-.698.598-1.197.399-.5-.2-.699-.798-.4-1.197C8.98 8.83 15.066 4.64 22.05 4.64c9.578 0 17.36 7.782 17.46 17.36l2.894-2.893c.299-.4.898-.4 1.297 0 .399.399.399.898 0 1.297ZM37.814 29.184C35.02 35.17 29.034 39.36 21.95 39.36c-9.578 0-17.36-7.783-17.46-17.36l-2.894 2.893c-.299.299-.898.299-1.297 0-.399-.4-.399-.898 0-1.297l4.59-4.59c.3-.4.998-.499 1.397-.1l4.59 4.59c.398.399.398.898 0 1.297-.3.3-.899.3-1.298 0L6.385 21.6v.2c0 8.58 6.985 15.564 15.565 15.564 6.286 0 11.773-3.691 14.168-9.08.2-.498.798-.698 1.197-.498.599.4.798.898.5 1.397Z"
  }));
});
Refresh.displayName = 'Refresh';
Refresh.defaultProps = {
  'aria-label': 'Refresh'
};
export default Refresh;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Refresh.js
// module id = 3892
// module chunks = 11